import { render } from "./JoinCrawl.vue?vue&type=template&id=705b2ff9&scoped=true"
import script from "./JoinCrawl.vue?vue&type=script&lang=js"
export * from "./JoinCrawl.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-705b2ff9"

export default script